import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Result, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { Box, Typography, useTheme } from '@mui/material';

const NotFound = () => {
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  // 다국어
  const { t, i18n } = useTranslation(); // useTranslation 훅 사용
  const [language, setLanguage] = React.useState(localStorage.getItem('language') || 'ko');
  // MUI 테마
  const theme = useTheme();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 1000); // 1초 (1000ms) 후에 화면을 출력

    return () => clearTimeout(timer); // 컴포넌트 언마운트 시 타이머 정리
  }, []);

  useEffect(() => {
    i18n.changeLanguage(language); // 언어가 변경되면 i18n의 언어를 변경

    const handleStorageChange = () => {
      setLanguage(localStorage.getItem('language') || 'ko');
    };
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [language, i18n]); // language 또는 i18n이 변경될 때마다 언어를 변경

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
      }}
    >
      {!isLoaded ? (
        <Spin size="large" /> // 로딩 스피너 표시 (필요 시 antd의 Spin 컴포넌트 사용)
      ) : (
        <Result
          status="404"
          title={
            <Typography
              style={{ textAlign: 'center' }}
              color={theme.palette.fieldText?.title} // 커스텀 색상 사용
            >
              {t('not_found_page.title')}
            </Typography>
          }
          subTitle={
            <Typography style={{ textAlign: 'center' }} color={theme.palette.fieldText?.title}>
              {t('not_found_page.sub_title1')}
              <br />
              {t('not_found_page.sub_title2')}
            </Typography>
          }
          extra={
            <Button type="primary" onClick={() => navigate(-1)}>
              {t('not_found_page.go_back')}
            </Button>
          }
          style={{ width: '400px' }} // 필요에 따라 결과 컴포넌트의 너비를 조정할 수 있습니다.
        />
      )}
    </Box>
  );
};

export default NotFound;
